import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'FAQ', href: '#faq' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <span className={`font-cormorant text-2xl md:text-3xl font-semibold tracking-widest transition-colors duration-500 ${scrolled ? 'text-[#2C2B29]' : 'text-white'}`}>
            MG<span className="text-[#C4A45A]">+</span>
          </span>
          <span className={`block text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.25em] uppercase font-raleway font-light transition-colors duration-500 ${scrolled ? 'text-[#8B8680]' : 'text-white/80'}`}>
            Saúde &amp; Estética
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNav(link.href)}
                className={`text-xs tracking-[0.15em] uppercase font-raleway font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-[#6B6560] hover:text-[#C4A45A]' : 'text-white/90 hover:text-[#C4A45A]'
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA Button Desktop */}
        <a
          href="https://wa.me/551122289498?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20na%20MG%2B%20Saúde%20%26%20Estética."
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#C4A45A] text-white text-xs tracking-[0.15em] uppercase font-raleway font-medium px-5 py-2.5 rounded-full hover:bg-[#B8975A] transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          Agendar Avaliação
        </a>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer transition-colors duration-300 ${scrolled ? 'text-[#2C2B29]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-[#F0EAE0] transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <ul className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNav(link.href)}
                className="text-sm tracking-[0.12em] uppercase font-raleway text-[#6B6560] hover:text-[#C4A45A] transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            </li>
          ))}
          <li>
            <a
              href="https://wa.me/551122289498?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação%20na%20MG%2B%20Saúde%20%26%20Estética."
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center bg-[#C4A45A] text-white text-xs tracking-[0.15em] uppercase font-raleway font-medium px-5 py-3 rounded-full hover:bg-[#B8975A] transition-all cursor-pointer whitespace-nowrap"
            >
              Agendar Avaliação
            </a>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Navbar;
